// hooks/useGraphQLChat.ts
import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';

const SEND_MESSAGE_MUTATION = gql(`
  mutation SendMessage($message: String!) {
    sendMessage(message: $message)
  }
`);

type ChatMessage = {
  id: number;
  message: string;
  sender: 'user' | 'assistant';
};

export function useGraphQLChat() {
  const [messages, setMessages] = useState<ChatMessage[]>([
    {
      id: 0,
      message: `👋 **Welcome to the AngelList India Assistant!**

I'm here to help you with any questions about our platform or general inquiries. I can assist with:


• **Investment Guidance** - Learn about investment processes and requirements
• **Platform Features** - Understand how to use our platform effectively
• **General Support** - Answer questions about our services

Feel free to ask me anything! How can I help you today?`,
      sender: 'assistant',
    },
  ]);
  const [sendMessageMutation, { loading }] = useMutation(SEND_MESSAGE_MUTATION);

  const sendMessage = async (input: string) => {
    const userId = messages.length + 1;

    setMessages(prev => [...prev, { id: userId, message: input, sender: 'user' }]);

    try {
      const { data } = await sendMessageMutation({ variables: { message: input } });
      const reply = data?.sendMessage;

      setMessages(prev => [...prev, { id: userId + 1, message: reply, sender: 'assistant' }]);
    } catch (err) {
      console.error('Error:', err);
      setMessages(prev => [
        ...prev,
        { id: userId + 1, message: 'Sorry, something went wrong.', sender: 'assistant' },
      ]);
    }
  };

  return { messages, sendMessage, loading };
}
